import BaseFormPresenter from "../../../base/BaseFormPresenter";

class ClientFormPresenter extends BaseFormPresenter {
  async save() {
    const user = this.view.getCurrentUser();
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.createdBy = user.id;
    }

    try {
      await this.upsertUseCase.execute(collection, this.change);
      this.change = {};
    } catch (error) {
      throw error;
    }
  }
}

export default ClientFormPresenter;
